"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import {
  extractRegionFromCurrentSlug,
  resetSyncCdnImageSize,
  vehicleLinkBuilderByReference,
} from "@/components/package-components/utils";
import { VehicleCardProps } from "../../props";

export default function VehicleFeatured01({
  vehicle,
  idx,
  ...props
}: VehicleCardProps) {
  const site = props.data.site;
  const region = extractRegionFromCurrentSlug(props.data.page?.currentSlug);
  const vehicleUrl =
    vehicleLinkBuilderByReference({
      vehicle,
      site: {
        subdomain: site?.subdomain as string,
        customDomain: site?.customDomain ?? "",
        preferences: site?.preferences ?? [],
      },
      region,
    }) ?? "/";

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isClient) return null;

  const imageThumb = resetSyncCdnImageSize(
    [vehicle.images?.split(",")[0]],
    "652",
    "488"
  )[0];

  const textAnimate = {
    offscreen: { y: 100, opacity: 0 },
    onscreen: { y: 0, opacity: 1 },
    transition: { type: "spring", bounce: 0.4, duration: 0.5 },
  };

  return (
    <Link href={vehicleUrl} prefetch passHref>
      <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="relative w-full h-80 rounded-lg overflow-hidden hover:opacity-75 xl:w-auto min-w-[300px]"
      >
        <Image
          src={imageThumb}
          alt={`Imagem do veículo ${vehicle.make} ${vehicle.model} ${vehicle.version} - ${vehicle.id} ${idx}`}
          fill
          sizes="(min-width:1280px) 300px, 100vw"
          className="object-cover object-center"
          placeholder="blur"
          blurDataURL="https://sync-front-end-resources.s3.sa-east-1.amazonaws.com/blur-image.jpg"
          priority={idx < 3}
        />

        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-t from-gray-800/50 to-transparent"
        />

        {/* texto animado */}
        <motion.div
          variants={textAnimate}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true }}
          className="relative flex h-full w-full items-end justify-center p-6"
        >
          <span className="text-center text-xl font-bold text-white">
            {vehicle.make} <span>{vehicle.model}</span>
          </span>
        </motion.div>
      </motion.div>
    </Link>
  );
}
